import {Component, Inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SampleDataClient, WeatherForecast} from '../api/WickedApiClient';

@Component({
    selector: 'app-fetch-data',
    templateUrl: './fetch-data.component.html'
})
export class FetchDataComponent {
    public forecasts: WeatherForecast[];

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        var client = new SampleDataClient(http, baseUrl);
        client.weatherForecasts().subscribe(result => {
            this.forecasts = result;
        }, error => console.error(error));


    }
}

